import { Mic } from "lucide-react";
import Centered from "./Centered";

/**
 * Pre-flight permissions card. Triggers the browser mic/camera prompt via
 * `onAllow` (which is wired up in the parent and handles the strict
 * 1280×720 hardware enforcement for video campaigns).
 */
export default function ScreenPreflight({ campaign, onAllow, onSkip }) {
  const wantsVideo = !!campaign?.video_enabled;
  return (
    <Centered>
      <div className="bg-white border border-[var(--rl-border)] p-10 max-w-lg w-full text-center" data-testid="preflight-screen">
        <Mic className="w-10 h-10 text-[var(--rl-brand)] mx-auto" />
        <h1 className="font-display font-black text-3xl mt-5" data-testid="preflight-title">
          {wantsVideo ? "Microphone + Camera Access" : "Microphone Access"}
        </h1>
        <p className="text-[var(--rl-text-secondary)] mt-3 leading-relaxed">
          {wantsVideo
            ? "This study is a video interview. We'll use your microphone for voice answers and your webcam to capture facial cues. Your browser will ask you to grant both. You can switch to typing at any time."
            : "We'll use your microphone for voice answers. You can switch to typing at any time."}
        </p>
        <button onClick={onAllow} className="mt-8 w-full bg-[var(--rl-text)] text-white py-3 font-semibold hover:bg-[var(--rl-brand)] transition-colors" data-testid="preflight-allow-btn">
          {wantsVideo ? "Allow Microphone + Camera" : "Allow Microphone"}
        </button>
        <button onClick={onSkip} className="mt-3 w-full bg-transparent border border-[var(--rl-border)] text-[var(--rl-text)] py-3 font-semibold hover:border-[var(--rl-text)] transition-colors" data-testid="preflight-skip-btn">Skip — type only</button>
      </div>
    </Centered>
  );
}
